<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-12-17 17:38:09
 * @LastEditTime: 2022-03-22 09:50:54
-->
<template>
  <div class="center-params">
    <div class="centerInfo-top_operations">
      <div class="top_title">
        {{ $t('lang.Monitor.terminalRealTimeData') }}
      </div>
      <div class="setting-icon">
        <el-tooltip :content="$t('lang.Monitor.realTimeMonitoring')" effect="dark" placement="top">
          <i class="el-icon-video-camera" v-if="ctid == 82" @click="openView"></i>
        </el-tooltip>
      </div>
      <div class="setting-icon">
        <el-tooltip :content="$t('lang.Monitor.setVariable')" effect="dark" placement="top">
          <i class="el-icon-setting" @click="setParams"></i>
        </el-tooltip>
      </div>
      <div>
        <i class="icon-quanping Qp-Icon" @click="enLarge('top')"></i>
      </div>
    </div>
    <div class="terminalSelect">
      <div>
        <span>{{ $t('lang.varlist.terminalType') }}：</span>
        <el-select size="mini" clearable v-model="dataType">
          <el-option label="Modbus" :value="0"></el-option>
          <el-option label="Io Control" :value="1"></el-option>
        </el-select>
      </div>
      <div v-show="dataType === 0" style="margin-left: 10px;display: flex;align-items: center;">
        <span style="width: 80px;">{{ $t('lang.terminalList.SlaveID') }}：</span>
        <el-input size="mini" v-model.number="sidSelected" :placeholder="$t('lang.terminalList.form3')"
          clearable></el-input>
      </div>
    </div>
    <div class="centerInfo-top_scroll">
      <div class="centerInfo-top_tags">
        <div class="no-permission" v-if="Permission.indexOf(225) === -1">
          无权限
        </div>
        <div v-else-if="paramsList.length > 0" class="card_box">
          <div v-for="(item, index) in paramsList" :key="item.id" class="card" shadow="hover">
            <div style="margin-bottom: 4px;"> {{ $t("lang.smartlink.slaveID") }} ：{{ item.sid }}</div>
            <div>{{ $t("lang.Monitor.terminalName") }}：{{ item.dtuName }}</div>
            <div v-if="Array.isArray(item.unit)" style="display: flex; flex-direction: column" class="test">
              <span style="margin-top: 5px;display:flex ;align-items: center;" :style="`color:blue;`" v-for="(i, index) in item.name">{{
                item.name[index] + "："
              }}
                <i style="color:yellow;font-size: 16px;">{{
                  item.strVal[index]
                }}</i>
                <span style="font-size: 12px;margin-left: 6px;">{{
                  item.unit[index] | unitFormat
                }}</span>
              </span>
            </div>
            <div v-else style="margin-top: 5px">
              <div v-if="item.isAlter == 0">
                <div v-if="item.registerType === 2">
                  <el-switch :value="item.strVal == 0 ? false : true" @change="(val) => switchChange(val, item)"
                    active-color="#13ce66" inactive-color="#ff4949" size="mini" style="margin-right: 5px"
                    disabled></el-switch>
                  {{
                    item.strVal == "0"
                    ? $t("lang.Monitor.Close")
                    : $t("lang.Monitor.Open")
                  }}
                </div>
                <div v-if="item.registerType === 4">
                  <span :style="`color:blue;`">{{
                    item.name + "："
                  }}</span>
                  <span style="color:yellow;">{{ item.strVal }}</span>
                  <span style="font-size: 12px;margin-left: 6px;">{{
                    item.unit |
                    unitFormat
                  }}</span>
                </div>
              </div>
              <!-- 当此变量可操作时 -->
              <div v-if="item.isAlter == 1" style="margin-top: 5px;font-size: 16px;display: flex;align-items: center;">
                <span :style="`color:blue;`">{{ item.name + "：" }}</span>
                <div v-if="item.registerType === 1">
                  <el-switch :value="item.strVal == 0 ? false : true" @change="(val) => switchChange(val, item)"
                    active-color="#13ce66" inactive-color="#ff4949" size="mini" style="margin-right: 5px"></el-switch>
                  {{
                    item.strVal == "0"
                    ? $t("lang.Monitor.Close")
                    : $t("lang.Monitor.Open")
                  }}
                </div>
                <div v-else-if="item.registerType === 3" @click="editValue(item)">
                  <span style="color:yellow;">{{ item.strVal }}</span> <span style="margin-left: 8px;">{{
                    item.unit |
                    unitFormat
                  }}</span> <i class="el-icon-edit"></i>
                </div>
                <br />
              </div>
            </div>
            <span style="margin-top: 5px;display: inline-block;">
              {{ $t("lang.Monitor.collectionTime") }}：
              <span style="font-size: 14px;">{{ item.cts | formatDate }}</span></span>
          </div>
        </div>
        <div v-else-if="!isLoding" class="no-data">
          <p>{{ $t("lang.Monitor.noData") }}</p>
        </div>
        <div v-else class="no-data">
          <p>{{ $t("lang.Monitor.loading") }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="centerInfo-top-pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div> -->
    <el-dialog destroy-on-close :title="$t('lang.Monitor.realTimeMonitoring')" :visible.sync="videoDialog">
      <!-- <video-player :options="playerOption"></video-player> -->
      <iframe allowfullscreen allow="payment" src="http://singleyun.com:50000/doc/page/login.asp"
        frameborder="0"></iframe>
    </el-dialog>
    <setting-params ref="settingParams" @updateParams="getDeviceParams" @loding="lodingData"></setting-params>
  </div>
</template>
<script>
import {
  getParamsByDid,
  deleteParams,
  setIocontrolSwitch,
  setModbusSwitch,
  setModbusValue,
} from "@/api/cloudMonitor/dashboard";
import { unitObj } from "@/utils/paramsConfig";
import settingParams from "../settingParams";
import { getPermission } from "@/cookie/cookie";
import { getuser_ctid } from "@/localStorage/localStorage";
import {
  queryTerminal
} from '@/api/cloudMonitor/terminalList'
export default {
  props: ["deviceDid", "groupMonitorType", "deviceId"],
  components: {
    settingParams,
  },
  data() {
    return {
      paramsList: [],
      videoDialog: false,
      unitObj, // 变量单位对象
      paramsTimer: null, // 变量定时器，10s刷新一次变量展示'
      Permission: [],
      dataList: [],
      playerOption: {
        height: "350",
        language: "zh-CN",
        loop: true,
        aspectRatio: "16:9",
        sources: [
          {
            type: "video/mp4",
            src: "http://vjs.zencdn.net/v/oceans.mp4",
          },
        ],
      },
      ctid: "",
      disabledList: [],
      sidSelected: undefined,
      pageSize: 999,
      currentPage: 1,
      total: 0,
      dataType: undefined,
      isLoding: true,
      colorList: ['#FE0100', '#FD9802', '#FFFF00', '#03CA01', '#0254CE', '#8800CB', '#FE6603', '#FFCD01', '#ACE503', '#0199CA', '#2100C8', '#FD037C'],
      color: {},
      colorIndex: 0,
    };
  },
  watch: {
    deviceDid: {
      immediate: true,
      handler() {
        this.paramsList = [];
        if (this.deviceDid && this.Permission.indexOf(225) !== -1) {
          this.getDeviceParams();
          clearInterval(this.paramsTimer);
          this.paramsTimer = setInterval(() => {
            this.getDeviceParams();
          }, 20000);
        }
      },
    },
    deviceId: {
      immediate: true,
      handler() {
        queryTerminal({
          deviceId: this.deviceId,
          current: 1,
          size: 999,
          sid: this.sidSelected ? this.sidSelected : undefined,
        }).then(res => {
          this.terminalList = res.data.data.records
        })
      }
    },
    sidSelected: {
      handler() {
        this.getDeviceParams()
      }
    },
    dataType: {
      handler(newV) {
        this.isLoding = true
        if (newV === 1) {
          this.sidSelected = undefined
        }
        this.getDeviceParams()
      }
    }
  },
  activated() {
    this.ctid = getuser_ctid();
    this.lodingData();
    this.colorIndex = 0;
  },
  deactivated() {
    clearInterval(this.paramsTimer);
  },
  filters: {
    unitFormat(e) {
      // if (e) return e.substring(e.indexOf("(") + 1, e.lastIndexOf(")"));
      if (e) {
        if (unitObj[e]) {
          if (e == 7) {
            return "";
          } else {
            return unitObj[e];
          }
        } else {
          unitObj[e] = e;
          return unitObj[e];
        }
      }
    },
    // 将时间戳转化为yyyy-mm-dd HH:MM:SS格式
    formatDate(e) {
      if (e) {
        let date = new Date(e);
        let Y = date.getFullYear() + "-";
        let M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        let D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        let h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        let m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        let s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      }
    },
  },
  methods: {
    colorObj(n) {
      if (this.color[n]) {
        return this.color[n]
      } else {
        // this.color[n] = this.color[this.colorIndex]
        this.$set(this.color, n, this.colorList[this.colorIndex])
        if (this.colorIndex >= this.colorList.length) {
          this.colorIndex = 0
        } else {
          this.colorIndex += 1
        }
        return this.color[n]
      }
    },
    // 获取某个设备展示的变量
    lodingData() {
      clearInterval(this.paramsTimer);
      this.Permission = getPermission();
      if (this.deviceDid && this.Permission.indexOf(225) !== -1) {
        this.getDeviceParams();
        this.paramsTimer = setInterval(() => {
          this.getDeviceParams();
        }, 20000);
      }
    },
    getDeviceParams() {
      getParamsByDid(this.deviceDid, this.dataType !== undefined ? this.dataType : undefined, this.sidSelected !== undefined ? this.sidSelected : undefined, this.currentPage, this.pageSize)
        .then((res) => {
          if (res.data.code === 0) {
            let resData = [];
            let wsd = [];
            this.dataList = res.data.data.records;
            this.total = res.data.data.total;
            let aa = this.disabledList;
            for (let i = 0; i < aa.length; i++) {
              if (
                this.paramsList[
                  this.paramsList.findIndex(
                    (v) => v.vid == this.disabledList[i]
                  )
                ].strVal !=
                this.dataList[
                  this.dataList.findIndex((v) => v.vid == this.disabledList[i])
                ].strVal
              ) {
                this.disabledList = this.disabledList.filter(
                  (v) => v != this.disabledList[i]
                );
              }
            }
            if (this.groupMonitorType == 0) {
              this.paramsList = res.data.data.records;
            } else {
              wsd = res.data.data.records.filter((v) => v.unit == 1 || v.unit == 4);
              resData = res.data.data.records.filter((v) => v.unit == 0);
              let data = [];
              if (wsd.length != 1) {
                for (let i = 0; i < wsd.length - 1; i++) {
                  //[]dtuid一样的合并入数组
                  let list = [];
                  list.push(wsd[i]);
                  let j = i + 1;
                  for (; j < wsd.length; j++) {
                    if (i.dtuid == j.dtuid) {
                      list.push(wsd[j]);
                      i++;
                    } else {
                      break;
                    }
                  }
                  data.push({
                    cts: list[0].cts,
                    did: list[0].did,
                    dtuName: list[0].dtuName,
                    dtuid: list[0].dtuName,
                    factor: list[0].factor,
                    id: list[0].id,
                    index: list[0].index,
                    // name: [list[0].name, list[1].name],
                    name: ((list) => {
                      let data1 = [];
                      list.forEach((v) => {
                        data1.push(v.name);
                      });
                      return data1;
                    })(list),
                    registerType: list[0].register,
                    // strVal: [list[0].strVal, list[1].strVal],
                    strVal: ((list) => {
                      let data1 = [];
                      list.forEach((v) => {
                        data1.push(v.strVal);
                      });
                      return data1;
                    })(list),
                    ts: list[0].ts,
                    unit: ((list) => {
                      let data1 = [];
                      list.forEach((v) => {
                        data1.push(v.unit);
                      });
                      return data1;
                    })(list),
                    val: list[0].val,
                    vid: list[0].vid,
                    isAlter: list[0].isAlter,
                  });
                }
              } else {
                data = wsd;
              }
              this.paramsList = [...resData, ...data];
            }
            this.isLoding = false;
          }
        })
        .catch(() => { });
    },
    // 设置变量
    setParams() {
      this.$refs.settingParams.show(this.deviceDid, this.dataList);
    },
    // 点击扩展符
    enLarge(type) {
      this.$emit("enLarge", type);
    },
    // 设置变量开关值
    switchChange(value, item) {
      if (this.Permission.indexOf(267) !== -1) {
        let tips = (tips = this.$t("lang.openvpn.open"));
        if (value) {
          tips = this.$t("lang.openvpn.open");
        } else {
          tips = this.$t("lang.openvpn.close");
        }
        this.$confirm(
          `${this.$t("lang.user.Confirmation")}${tips}${this.$t(
            "lang.Monitor.variable"
          )}？`,
          this.$t("lang.editVar.msg22"),
          {
            cancelButtonText: this.$t("lang.editVar.msg24"),
            confirmButtonText: this.$t("lang.editVar.msg23"),
            center: true,
            type: "warning",
          }
        ).then(() => {
          this.disabledList.push(item.vid);
          let params = {
            dtuId: item.dtuid,
            vid: item.vid,
            value: value === true ? 1 : 0,
          };
          if (item.type == 1) {
            setIocontrolSwitch(params)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.Button.successSetting"));
                  this.getDeviceParams();
                } else {
                  this.$message.error(this.$t("lang.Button.failSetting"));
                }
              })
              .catch(() => {
                this.$message.warning(this.$t("lang.Button.failOperation"));
              });
          } else {
            setModbusSwitch(params)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.Button.successSetting"));
                  this.getDeviceParams();
                } else {
                  this.$message.error(this.$t("lang.Button.failSetting"));
                }
              })
              .catch(() => {
                this.$message.warning(this.$t("lang.Button.failOperation"));
              });
          }
        });
      } else {
        this.$message.warning(this.$t("lang.Button.noPermission"));
      }
    },
    test() {
      this.videoDialog = true;
    },
    imgForamt(e) {
      return require("@/assets/wsd.png");
    },
    openView() {
      window.open(
        "http://singleyun.com:50000/doc/page/login.asp",
        "实时监控",
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=" +
        1200 +
        ", height=" +
        800 +
        ", top=" +
        200 +
        ", left=" +
        200
      );
    },
    editValue(i) {
      let a = [1, 3, 5];
      let b = [2, 4, 6];
      //弹出输入框
      this.$prompt(
        this.$t("lang.Monitor.pleaseModifyValu"),
        this.$t("lang.Button.tips"),
        {
          confirmButtonText: this.$t("lang.Button.confirm"),
          cancelButtonText: this.$t("lang.Button.cancel"),
          inputValue: i.strVal,
          inputValidator: (valeu) => {
            //有符号整数
            if (a.includes(i.dataType)) {
              //int32之内的整数,且必须是数字,且非空
              if (
                !/^[0-9]*$/.test(valeu) ||
                valeu > 2147483647 ||
                valeu < -2147483648 ||
                valeu == ""
              ) {
                return this.$t("lang.editVar.pleaseEnterInt32");
              }
              // if (valeu > 2147483647 || valeu < -2147483648) {
              //   return this.$t("lang.editVar.pleaseEnterInt32");
              // } else if (!/^[0-9]*$/.test(valeu)) {
              //   return this.$t("lang.editVar.pleaseEnterAValidValue");
              // }
            } else if (b.includes(i.dataType)) {
              //uint32之内的整数,且必须是数字,且非空
              if (
                !/^[0-9]*$/.test(valeu) ||
                valeu > 4294967295 ||
                valeu < 0 ||
                valeu == ""
              ) {
                return this.$t("lang.editVar.pleaseEnterUint32");
              }
              // if (valeu > 4294967295 || valeu < 0) {
              //   return this.$t("lang.editVar.pleaseEnterUint32");
              // } else if (!/^[0-9]*$/.test(valeu)) {
              //   return this.$t("lang.editVar.pleaseEnterAValidValue");
              // }
            } else if (i.dataType == 7 || i.dataType == 8) {
              //必须带小数点
              return /^\d+\.\d+$/.test(valeu);
            } else if (i.dataType == 9) {
              //非空字符串
              return valeu.length > 0;
            }
          },
          //非空时提示请输入一个有效值
          inputErrorMessage: this.$t("lang.editVar.pleaseEnterAValidValue"),
          closeOnClickModal: false,
        }
      )
        .then(({ value }) => {
          setModbusValue({
            dtuId: i.dtuid,
            vid: i.vid,
            value: Number(value),
            type: i.registerType == 1 ? 0 : 1,
          }).then((res) => {
            this.$message({
              type: "success",
              message: this.$t("lang.Button.successEdit"),
            });
          });
        })
        .catch(() => { });
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
    },
  },
};
</script>
<style scoped>
.centerInfo-top_operations {
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.setting-icon {
  font-size: 22px;
  color: #606266;
  cursor: pointer;
  margin-right: 15px;
}

.Qp-Icon {
  margin-right: 10px;
  font-size: 18px;
  font-weight: bolder;
  color: rgb(0, 116, 199);
  cursor: pointer;
}

.centerInfo-top_scroll {
  height: 88%;
  overflow: scroll;
  margin-top: 20px;
}

.centerInfo-top_tags {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.centerInfo-top_tags>>>.el-tag {
  white-space: pre-wrap;
  line-height: 20px;
  height: 100% !important;
  min-height: 50px;
  min-width: 180px;
  font-size: 15px;
  padding: 15px 15px;
}

.variable {
  align-self: center;
  background-color: #409eff;
  padding: 10px;
}

.variable-item {
  margin-left: 20px;
  cursor: pointer;
  margin-top: 5px;
  color: white;
  font-size: 16px;
  line-height: 25px;
  border-radius: 4px;
}

.center-params {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

::-webkit-scrollbar-track-piece {
  background-color: #e9edfa;
}

::-webkit-scrollbar-corner {
  background-color: #e9edfa;
}

.no-permission {
  text-align: center;
  font-size: 20px;
  color: grey;
}

.card_box {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 240px);
  justify-content: center;
  gap: 10px;
}

.card {
  padding: 6px;
  /* background-image: linear-gradient(to bottom, #0f1325, #273261); */
  color: white;
  font-size: 16px;
  border: 4px;
  transition: all 0.5s;
  cursor: pointer;
  color: #fff;
  position: relative;
  background-size: 100% 100%;
  /* background: linear-gradient(160deg, #2f619e, #81c5fb); */
  background: #18b7fe;
  /* border: 2px solid #68DFCF; */
  /* font-weight: bold; */
  box-shadow: inset 0px 0px 14px 10px #2ea8ff;
}

.back_img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 50%;
  right: 4%;
}

.card:hover {
  /* background-color: #259ac9; */
  box-shadow: none !important;
}

.terminalSelect {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.centerInfo-top-pagination {
  margin: 0 auto;
  width: 76%;
}

.top_title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  font-weight: bolder;
}
</style>
